<template>
  <div class="financial-statement-item">
    <col-table :data="tableData" :pageSize="pageSize" :class="{ 'col-table--same': isSame, 'table-var': true }">
      <col-table-column label="日期" prop="endDate" :css="{ height: '50px' }">
        <template #header>
          <div class="date-header">
            <span>报告期<i class="iconfont icon-wenhao ml-4px" @click="popupVisible = true"></i></span>
            <span class="tongbi">
              {{ $t('同比')
              }}<span class="checkbox-wrap"><input type="checkbox" v-model="isSame" class="checkbox" /></span>
            </span>
          </div>
        </template>
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ scope.row.sortYear + scope.row.reportType }}</span>
            <span class="scale">{{ $t('同比') }}</span>
          </div>
        </template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>关键指标</template>
      </col-table-column>
      <col-table-column prop="operatingIncome" label="营业收入">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.operatingIncome).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.operatingIncomeYoY).color() }" class="scale">
              {{ $digitjs(scope.row.operatingIncomeYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="ownersOfTheCom" label="归母净利润">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.ownersOfTheCom).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.ownersOfTheComYoY).color() }" class="scale">
              {{ $digitjs(scope.row.ownersOfTheComYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="" label="扣非净利润" :css="{ marginBottom: '17px' }"></col-table-column>
      <col-table-column :css="css">
        <template #header>每股指标</template>
      </col-table-column>
      <col-table-column prop="eps" label="每股收益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.eps).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.epsYoY).color() }" class="scale">
              {{ $digitjs(scope.row.epsYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="netAssetsPS" label="每股净资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.netAssetsPS).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.netAssetsPSYoY).color() }" class="scale">
              {{ $digitjs(scope.row.netAssetsPSYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="" label="每股资本公积金"></col-table-column>
      <col-table-column prop="" label="每股未分配利润"></col-table-column>
      <col-table-column prop="operatingCashFlowPS" label="每股经营现金流" :css="{ marginBottom: '17px' }">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.operatingCashFlowPS).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.operatingCashFlowPSYoY).color() }" class="scale">
              {{ $digitjs(scope.row.operatingCashFlowPSYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>盈利能力</template>
      </col-table-column>
      <col-table-column prop="returnOnEquity" label="净资产收益率">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.returnOnEquity).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.returnOnEquityYoY).color() }" class="scale">
              {{ $digitjs(scope.row.returnOnEquityYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="" label="净资产收益率-摊薄"></col-table-column>
      <col-table-column prop="grossProfitMargin" label="毛利率">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.grossProfitMargin).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.grossProfitMarginYoY).color() }" class="scale">
              {{ $digitjs(scope.row.grossProfitMarginYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="" label="存货周转率" :css="{ marginBottom: '17px' }"></col-table-column>
      <col-table-column :css="css">
        <template #header>资本结构</template>
      </col-table-column>
      <col-table-column prop="debtAssetRatio" label="资产负债率">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.debtAssetRatio).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.debtAssetRatioYoY).color() }" class="scale">
              {{ $digitjs(scope.row.debtAssetRatioYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="" label="权益乘数" :css="{ marginBottom: '17px' }"></col-table-column>
      <col-table-column :css="css">
        <template #header>偿债能力</template>
      </col-table-column>
      <col-table-column prop="" label="流动比率"></col-table-column>
      <col-table-column prop="" label="速动比率" :css="{ marginBottom: '17px' }"></col-table-column>
      <col-table-column :css="css">
        <template #header>营运能力</template>
      </col-table-column>
      <col-table-column prop="" label="总资产周转率"></col-table-column>
      <col-table-column prop="" label="应收账款周转天数" :css="{ marginBottom: '17px' }"></col-table-column>
      <col-table-column :css="css">
        <template #header>成长能力</template>
      </col-table-column>
      <col-table-column prop="operatingIncomeYoY" label="营业收入同比增长率">
        <template slot-scope="scope">{{ $digitjs(scope.row.operatingIncomeYoY).convert() }}</template>
      </col-table-column>
      <col-table-column prop="netProfitYoY" label="净利润同比增长率">
        <template slot-scope="scope">{{ $digitjs(scope.row.netProfitYoY).convert() }}</template>
      </col-table-column>
    </col-table>
    <RkPopup :visible.sync="popupVisible"><ReportSheetPrompt /></RkPopup>
  </div>
</template>

<script>
import RkPopup from '@/components/common/Popup.vue'
import ReportSheetPrompt from '@/components/common/ReportSheetPrompt.vue'
export default {
  components: { RkPopup, ReportSheetPrompt },
  props: ['css'],
  data() {
    return {
      isSame: false,
      popupVisible: false,
      tableData: []
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    pageSize() {
      return this.isSame ? 1 : 2
    }
  },
  created() {
    this.getIndicatorsStatement()
  },
  methods: {
    formatA(val) {
      return (
        {
          12: 'F',
          9: 'Q3',
          6: 'I',
          1: 'Q1'
        }[val] ?? val
      )
    },
    getIndicatorsStatement() {
      let tableData = []
      this.$post(this.$api.f10[this.market] + '/finance/key-indicator', {
        symbol: this.symbol,
        startDate: this.$dayjs().subtract(5, 'year').format('YYYY-MM-DD')
      })
        .then((res) => {
          let reportTypeMap = {
            F: 4,
            Q3: 3,
            I: 2,
            Q1: 1
          }

          let data = res.data?.filter((item) => Boolean(reportTypeMap[this.formatA(item.reportType)])) ?? []

          data = data.map((item) => {
            item.sortYear = +this.$dayjs(item.reportDate).format('YYYY')
            item.reportType = this.formatA(item.reportType)
            return item
          })

          tableData = data.sort(
            (a, b) => b.sortYear - a.sortYear || reportTypeMap[b.reportType] - reportTypeMap[a.reportType]
          )

          return this.$post(this.$api.f10[this.market] + '/finance/income', {
            symbol: this.symbol,
            startDate: this.$dayjs().subtract(5, 'year').format('YYYY-MM-DD')
          })
        })
        .then((res) => {
          const incomeList = res.data ?? []
          const incomeMap = new Map()
          incomeList.forEach((item) => {
            const mapItem = incomeMap.get(item.reportDate)
            if (!mapItem) {
              incomeMap.set(item.reportDate, [item])
            } else {
              mapItem.push(item)
            }
          })
          this.tableData = tableData.map((item) => {
            const incomeMapItem = incomeMap.get(item.reportDate)
            if (incomeMapItem) {
              const incomeItem = incomeMapItem.find(
                (income) => this.formatA(income.reportType) === this.formatA(item.reportType)
              )
              if (incomeItem) {
                const {
                  operatingIncome,
                  operatingIncomeYoY,
                  ownersOfTheCom,
                  ownersOfTheComYoY,
                  netProfitYoY
                } = incomeItem
                item.operatingIncome = operatingIncome
                item.operatingIncomeYoY = operatingIncomeYoY
                item.ownersOfTheCom = ownersOfTheCom
                item.ownersOfTheComYoY = ownersOfTheComYoY
                // item.operatingIncomeYoY = operatingIncomeYoY
                item.netProfitYoY = netProfitYoY
              }
            }
            return item
          })
        })
    }
  }
}
</script>
